import React,{ useRef } from 'react';
import axios from 'axios'
import { Table, Input,Card, Button,Collapse,Switch,Spin,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Tabs,Tooltip } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined,DownloadOutlined } from '@ant-design/icons';
import { SearchOutlined,CameraOutlined,PlusOutlined,LoadingOutlined,DownOutlined,UpOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import { ReportEmailControls, submitReportWithEmail, reportSearchButtonLabel, REPORT_KEYS, initialReportEmailState } from '../reportEmailUtils';
import { LedgerJournalInfoAlert, TrialBalanceBreakdown, trialBalanceAccountKey } from '../journalReportUtils';
import * as reactstrp from 'reactstrap';

import {
  Col,
  Row,
} from 'reactstrap';
import '../tablestyle.css'; // Create this CSS file for custom styles
import ReactExport from "@ibrahimrahmani/react-export-excel";

const TRIAL_BALANCE_COLUMN_COUNT = 6;

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { TabPane } = Tabs;


const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


var token= ''
var sacco= ''
var bizuserid= ''

class ReportToPrint extends React.Component {

    state = {
    ...initialReportEmailState(),
      companyprofile:{}
    };
  
    componentDidMount(){
      if(localStorage.getItem("sacco")){
         sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
         bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
      
      }else{
         sacco= ''
         bizuserid= ''
      }
      
      if(localStorage.getItem("token")){
         token= localStorage.getItem("token")
      }else{
         token= ''
      }


      axios.defaults.headers={
        "Content-Type":"application/json",
        Authorization:`Token ${token}`
      }

      axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
      .then(res => {  
          this.setState({
            companyprofile: res.data
          })
  
      })
  
    }


    render() {
      const report = this.props.general_report || [];
      return (
        <div style={{padding:20}}>
           <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h5>{this.state.companyprofile.companydealership}</h5>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""
                  ?"":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>
                  </Col>

           </Row>

           <h2 style={{justifyContent:'center',display:'flex',alignSelf:'center'}}>{"TRIALBALANCE REPORT FROM "+this.props.dateone+" TO "+this.props.datetwo }</h2>
            <br></br>
            <br></br>
            <reactstrp.Table bordered>
              <thead>
                <tr>
                  <th>CODE</th>
                  <th>NAME</th>
                  {this.props.view_opening_balance?<th>Opening Balance</th>:null}
                  <th>DEBITS</th>
                  <th>CREDITS</th>
                </tr>
              </thead>
              <tbody>
                {report.map((item)=>(
                  <tr key={item.account_code || item.account || uuid()}>
                    <td>{item.account_code}</td>
                    <td>{item.account}</td>
                    {this.props.view_opening_balance? <td className="align-right">{<CurrencyFormat value={item.total_inst_balance} displayType={'text'} thousandSeparator={true}/>}</td>:null}
                    <td className="align-right">{<CurrencyFormat value={item.debit} displayType={'text'} thousandSeparator={true}/>}</td>
                    <td className="align-right">{<CurrencyFormat value={item.credit} displayType={'text'} thousandSeparator={true}/>}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={this.props.view_opening_balance?3:2} style={{fontWeight:'bolder'}}>TOTALS</td>
                  {this.props.view_opening_balance?<td></td>:null}
                  <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={(this.props.AllTotals.total_debit || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                  <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={(this.props.AllTotals.total_credit || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                </tr>
              </tbody>
            </reactstrp.Table>
          
        </div>
      );
    }
  }


class TrialBalanceDateRangeView extends React.Component {

  state = {
   ...initialReportEmailState(),
   datarequested:true,
   dateone:moment().format(dateFormat).toString(),
   datetwo:moment().format(dateFormat).toString(),
   companyprofile: {},

   balancesheet_report_assets:[],

   balancesheet_report_liability:[],
   balancesheet_report_equity:[],
   AllTotals:{},
   ledeger_details_model_visible:false,
   selected_record:{},

   balancesheet_report_incomes:[],
   balancesheet_report_expenses:[],

   general_report:[]   ,
   
   
   //view opening balance controller
   view_opening_balance:false,

   expandedAccountKey: null,
   breakdownLoadingKey: null,
   reportBasis: '',


  };

  accountRowKey = (item) => trialBalanceAccountKey(item);

  parseReportRows = (rows) => (rows || []).map((row) => ({
    ...row,
    breakdown: row.breakdown || [],
    breakdownLoaded: false,
    breakdownSummary: null,
    breakdownError: null,
  }));

  loadTrialBalanceReport = () => {
    const form_data = new FormData();
    form_data.append('dateone', this.state.dateone);
    form_data.append('datetwo', this.state.datetwo);
    form_data.append('sacco', sacco);

    submitReportWithEmail({
      reportKey: REPORT_KEYS.TRIAL_BALANCE_DATERANGE,
      params: { dateone: this.state.dateone, datetwo: this.state.datetwo, sacco },
      emailReport: this.state.email_report,
      receivingEmail: this.state.receiving_email,
      endpoint: serverconfig.backendserverurl + '/customqueries/get_trialbalance_daterange',
      formData: form_data,
      setLoading: (v) => this.setState({
        datarequested: v,
        ...(v ? { expandedAccountKey: null, reportBasis: '' } : {}),
      }),
      onSuccess: (res) => {
        this.setState({
          balancesheet_report_assets: JSON.parse(res.data.balancesheet_report_assets),
          balancesheet_report_liability: JSON.parse(res.data.balancesheet_report_liability),
          balancesheet_report_equity: JSON.parse(res.data.balancesheet_report_equity),
          balancesheet_report_incomes: JSON.parse(res.data.balancesheet_report_incomes),
          balancesheet_report_expenses: JSON.parse(res.data.balancesheet_report_expenses),
          general_report: this.parseReportRows(JSON.parse(res.data.general_report)),
          AllTotals: res.data.AllTotals,
        });
      },
      useInlineEmail: true,
    });
  };

  loadAccountBreakdown = (item) => {
    if (!item || item.breakdownLoaded) {
      return;
    }
    const rowKey = this.accountRowKey(item);
    this.setState({ breakdownLoadingKey: rowKey });
    const form_data = new FormData();
    form_data.append('sacco', sacco);
    form_data.append('account', item.account);
    form_data.append('dateone', this.state.dateone);
    form_data.append('datetwo', this.state.datetwo);
    axios.post(
      serverconfig.backendserverurl + '/customqueries/getTrialBalanceBreakdown_daterange',
      form_data,
      { timeout: 120000 }
    )
      .then((res) => {
        const breakdown = res.data.breakdown || [];
        const breakdownError = res.data.error_detail || null;
        const breakdownSummary = {
          trial_balance_debit: res.data.trial_balance_debit,
          trial_balance_credit: res.data.trial_balance_credit,
          total_debit: res.data.total_debit,
          total_credit: res.data.total_credit,
        };
        const merge = (list) =>
          list.map((row) =>
            this.accountRowKey(row) === rowKey
              ? { ...row, breakdown, breakdownLoaded: true, breakdownSummary, breakdownError }
              : row
          );
        this.setState({
          general_report: merge(this.state.general_report),
          reportBasis: res.data.report_basis || '',
          breakdownLoadingKey: null,
        });
      })
      .catch((err) => {
        console.log(err);
        message.error('Failed to load GL breakdown for this account');
        this.setState({ breakdownLoadingKey: null });
      });
  };

  toggleAccountBreakdown = (item) => {
    const rowKey = this.accountRowKey(item);
    if (this.state.expandedAccountKey === rowKey) {
      this.setState({ expandedAccountKey: null });
      return;
    }
    this.setState({ expandedAccountKey: rowKey });
    if (!item.breakdownLoaded) {
      this.loadAccountBreakdown(item);
    }
  };


  componentDidMount(){
      if(localStorage.getItem("sacco")){
        sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
        bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
        sacco= ''
        bizuserid= ''
    }
    
    if(localStorage.getItem("token")){
        token= localStorage.getItem("token")
    }else{
        token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {
      this.setState((prev) => ({
        companyprofile: res.data,
        receiving_email: prev.receiving_email || res.data.company_email || '',
      }));
    });

    //get balance sheet
    this.loadTrialBalanceReport();
  
}


  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {
    
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return(
        <div>
        <LedgerJournalInfoAlert />
         <div style={{display: "none"}}>
             &nbsp;&nbsp;
            <ReportToPrint
            dateone={this.state.dateone}
            datetwo={this.state.datetwo}
            general_report={this.state.general_report}
            AllTotals={this.state.AllTotals}
            ref={el => (this.componentRef = el)}
            view_opening_balance={this.state.view_opening_balance}
            /> 

          </div>

          <div style={{overflowX:'auto'}}>
              
          <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header={"TRIALBALANCE REPORT FROM "+this.state.dateone+" TO "+this.state.datetwo} key="1">
 
            <div style={{display:'flex',justifyContent:'flex-start',alignSelf:'flex-start',alignItems:'flex-start',flexDirection:'row'}}>
            {!this.state.email_report ? (
            <>
            <ReactToPrint
            trigger={() => 
            <Button type="primary"  shape="round" icon={<PrinterOutlined />} size={this.state.size}>
            Print
            </Button>
            }
            content={() => this.componentRef}
            />

            &nbsp;
            <ExcelFile filename={"Pisacco - Trial balance from "+this.state.dateone +" to "+this.state.datetwo}  element={<Button type='primary' icon={<DownloadOutlined/>}>Download (Excel)</Button>}>
              <ExcelSheet data={this.state.general_report} name={"TrialBalance report"}>
                    <ExcelColumn label="CODE" value="account_code"/>
                    <ExcelColumn label="NAME" value="account"/>
                    <ExcelColumn label="DEBITS" value="debit"/>
                    <ExcelColumn label="CREDITS" value="credit"/>
              </ExcelSheet>
            </ExcelFile>
              &nbsp;
            </>
            ) : null}

          <Form layout="inline">
          <FormItem label="Date">
              <RangePicker onChange={
              (date, dateString) =>{
                this.setState({ dateone: dateString[0]});
                this.setState({ datetwo: dateString[1]});
              }
            } format={dateFormat} />

          </FormItem>


          <FormItem label="Show Opening Balances">
            <Switch
              checked={this.state.view_opening_balance}
              onChange={val=>{this.setState({view_opening_balance:val})}}
              checkedChildren="True"
              unCheckedChildren="False"
              />
          </FormItem>


          <ReportEmailControls
            emailReport={this.state.email_report}
            receivingEmail={this.state.receiving_email}
            onEmailReportChange={(val) => this.setState({ email_report: val })}
            onReceivingEmailChange={(val) => this.setState({ receiving_email: val })}
            companyEmail={this.state.companyprofile.company_email}
          />

          <FormItem>
                <Button
                 onClick={() => this.loadTrialBalanceReport()}
                 type="primary" htmlType="button">{reportSearchButtonLabel(this.state.email_report)}</Button>
                </FormItem> 

          </Form>

            </div>

            <br></br>
            <reactstrp.Table bordered>
              <thead>
                <tr>
                  <th>Breakdown</th>
                  <th>CODE</th>
                  <th>NAME</th>
                  {this.state.view_opening_balance?<th>Opening Balance</th>:null}
                  <th>DEBITS</th>
                  <th>CREDITS</th>
                </tr>
              </thead>
              <tbody>
                {(this.state.general_report || []).map((item) => {
                  const rowKey = this.accountRowKey(item);
                  const colSpan = this.state.view_opening_balance
                    ? TRIAL_BALANCE_COLUMN_COUNT
                    : TRIAL_BALANCE_COLUMN_COUNT - 1;
                  return (
                    <React.Fragment key={rowKey}>
                      <tr>
                        <td>
                          <Button
                            type="link"
                            size="small"
                            loading={this.state.breakdownLoadingKey === rowKey}
                            icon={this.state.expandedAccountKey === rowKey ? <UpOutlined /> : <DownOutlined />}
                            onClick={() => this.toggleAccountBreakdown(item)}
                          >
                            {this.state.expandedAccountKey === rowKey ? 'Hide' : 'Show'}
                          </Button>
                        </td>
                        <td>{item.account_code}</td>
                        <td>{item.account}</td>
                        {this.state.view_opening_balance ? (
                          <td className="align-right">
                            <CurrencyFormat value={item.total_inst_balance} displayType="text" thousandSeparator />
                          </td>
                        ) : null}
                        <td className="align-right">
                          <CurrencyFormat value={item.debit} displayType="text" thousandSeparator />
                        </td>
                        <td className="align-right">
                          <CurrencyFormat value={item.credit} displayType="text" thousandSeparator />
                        </td>
                      </tr>
                      {this.state.expandedAccountKey === rowKey ? (
                        <tr>
                          <td colSpan={colSpan}>
                            {this.state.breakdownLoadingKey === rowKey ? (
                              <div style={{ padding: 24, textAlign: 'center' }}>
                                <Spin />
                              </div>
                            ) : (
                              <TrialBalanceBreakdown
                                breakdown={item.breakdown}
                                reportBasis={this.state.reportBasis}
                                summary={item.breakdownSummary}
                                errorDetail={item.breakdownError}
                              />
                            )}
                          </td>
                        </tr>
                      ) : null}
                    </React.Fragment>
                  );
                })}
                <tr>
                  <td colSpan={this.state.view_opening_balance?4:3} style={{fontWeight:'bolder'}}>TOTALS</td>
                  <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={(this.state.AllTotals.total_debit || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                  <td className="align-right" style={{fontWeight:'bolder'}}>{<CurrencyFormat value={(this.state.AllTotals.total_credit || 0).toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                </tr>
              </tbody>
            </reactstrp.Table>


          </Panel>
          </Collapse>

        </div>

        </div>

    )

    }

  }
}

export default TrialBalanceDateRangeView; 
